import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface Release {
  id: string
  version: string
  title: string
  description?: string
  created_at: string
  updated_at?: string
}

export function getReleasesAction(): Promise<ApiResponse<Release[]>> {
  const url = '/releases'
  return api.get<ApiResponse<Release[]>>(url)
}
